// FityH Internationalization - English, Kreyòl, Français, Español

const translations = {
  en: {
    // App
    appName: "FityH",
    tagline: "Connect. Share. Live.",
    
    // Auth
    login: "Login",
    register: "Sign Up",
    logout: "Logout",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    username: "Username",
    displayName: "Display Name",
    forgotPassword: "Forgot password?",
    noAccount: "No account? Sign up",
    hasAccount: "Have an account? Login",
    loginSuccess: "Logged in!",
    registerSuccess: "Account created!",
    
    // Profile
    profile: "Profile",
    editProfile: "Edit Profile",
    bio: "Bio",
    followers: "Followers",
    following: "Following",
    posts: "Posts",
    follow: "Follow",
    unfollow: "Unfollow",
    blocked: "Blocked",
    
    // Feed
    home: "Home",
    feed: "Feed",
    explore: "Explore",
    newPost: "New Post",
    whatsHappening: "What's happening?",
    post: "Post",
    like: "Like",
    comment: "Comment",
    share: "Share",
    comments: "Comments",
    noPostsYet: "No posts yet",
    startFollowing: "Start following people to see their posts",
    
    // Chat
    chat: "Chat",
    chats: "Conversations",
    messages: "Messages",
    newMessage: "New Message",
    typeMessage: "Type a message...",
    send: "Send",
    online: "Online",
    offline: "Offline",
    sent: "Sent",
    delivered: "Delivered",
    seen: "Seen",
    newChat: "New Chat",
    groupChat: "Group Chat",
    
    // Notifications
    notifications: "Notifications",
    noNotifications: "No notifications",
    markAllRead: "Mark all as read",
    newFollower: "started following you",
    likedPost: "liked your post",
    commentedPost: "commented on your post",
    sentMessage: "sent you a message",
    
    // Search
    search: "Search",
    searchUsers: "Search users...",
    noResults: "No results",
    
    // Settings
    settings: "Settings",
    language: "Language",
    theme: "Theme",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    privacy: "Privacy",
    privateAccount: "Private Account",
    blockedUsers: "Blocked Users",
    deleteAccount: "Delete Account",
    about: "About",
    help: "Help",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    
    // Actions
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    report: "Report",
    block: "Block",
    unblock: "Unblock",
    confirm: "Confirm",
    
    // Errors
    error: "Error",
    errorOccurred: "An error occurred",
    tryAgain: "Try again",
    invalidCredentials: "Invalid email or password",
    emailTaken: "Email already taken",
    usernameTaken: "Username already taken",
    
    // Success
    success: "Success",
    saved: "Saved!",
    posted: "Posted!",
    deleted: "Deleted!",
    
    // Time
    now: "now",
    minutesAgo: "min ago",
    hoursAgo: "hours ago",
    daysAgo: "days ago",
    
    // Empty states
    noPosts: "No posts yet",
    noChats: "No conversations",
    noFollowers: "No followers",
    noFollowing: "Not following anyone",
    
    // Appointments
    appointments: "Appointments",
    manageAppointments: "Manage your appointments",
    myServices: "I Provide Services",
    myAppointments: "My Appointments",
    bookAppointment: "Book Appointment",
    chooseDate: "Choose Date",
    chooseTime: "Choose Time",
    noSlotsAvailable: "No slots available for this day",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    notesOptional: "Notes (Optional)",
    messageToProvider: "Message for provider...",
    continueBtn: "Continue",
    back: "Back",
    appointmentSummary: "Appointment Summary",
    service: "Service",
    date: "Date",
    time: "Time",
    duration: "Duration",
    minutes: "minutes",
    price: "Price",
    free: "Free",
    name: "Name",
    phone: "Phone",
    confirmBooking: "Confirm Booking",
    appointmentCreated: "Appointment created! Provider will confirm.",
    fillAllFields: "Fill in all required fields",
    invalidEmail: "Enter a valid email address",
    cannotCreateAppointment: "Cannot create appointment",
    pending: "Pending",
    confirmed: "Confirmed",
    completed: "Completed",
    cancelled: "Cancelled",
    rejected: "Rejected",
    all: "All",
    accept: "Accept",
    reject: "Reject",
    cancel: "Cancel",
    markComplete: "Mark Complete",
    noAppointments: "No appointments",
    whenClientsBook: "When clients book appointments with you, they will appear here",
    whenYouBook: "When you book appointments, they will appear here",
    appointmentConfirmed: "Appointment confirmed!",
    appointmentRejected: "Appointment rejected!",
    appointmentUpdated: "Appointment updated!",
    appointmentCancelled: "Appointment cancelled!",
    confirmCancel: "Are you sure you want to cancel this appointment?",
    
    // Payment
    payment: "Payment",
    payNow: "Pay Now",
    payLater: "Pay Later",
    payWithPayPal: "Pay with PayPal",
    payWithCard: "Pay with Card",
    paymentRequired: "Payment required to confirm booking",
    paymentSuccess: "Payment successful!",
    paymentFailed: "Payment failed",
    proceedToPayment: "Proceed to Payment",
    
    // Landing Page
    theFutureOfSocial: "The Future of Social Media",
    whereCreators: "Where Creators",
    thriveAndEarn: "Thrive & Earn",
    landingSubheadline: "A next-gen social platform where ideas, photos, and videos live together — and creators grow their community and income.",
    startCreatingFree: "Start Creating Free",
    exploreContent: "Explore Content",
    everythingYouNeed: "Everything You Need to",
    succeed: "Succeed",
    powerfulTools: "Powerful tools designed for modern creators",
    liveStreaming: "Live Streaming",
    liveStreamingDesc: "Go live and connect with your audience in real-time",
    aiCreatorStudio: "AI Creator Studio",
    aiCreatorStudioDesc: "Generate stunning videos and images with AI",
    creatorEconomy: "Creator Economy",
    creatorEconomyDesc: "Earn coins, tips, and subscriptions from your fans",
    safeAndSecure: "Safe & Secure",
    safeAndSecureDesc: "Your privacy and security are our top priority",
    lovedByCreators: "Loved by Creators Worldwide",
    joinTheRevolution: "Join the",
    revolution: "Revolution",
    joinRevolutionDesc: "Thousands of creators have already made FityH their home. Start your journey today and unlock your full potential.",
    globalCommunity: "Global Community",
    creatorRewards: "Creator Rewards",
    supportiveCulture: "Supportive Culture",
    createYourAccount: "Create Your Account",
    privacy: "Privacy",
    rules: "Rules",
    contactUs: "Contact",
    allRightsReserved: "All rights reserved.",
    
    // Marketplace
    marketplace: "Marketplace",
    searchProducts: "Search products...",
    noProducts: "No products",
    startSelling: "Start selling your first product!",
    listAProduct: "List a product",
    sell: "Sell",
    all: "All"
  },

  ht: {
    // App
    appName: "FityH",
    tagline: "Konekte. Pataje. Viv.",
    
    // Auth
    login: "Konekte",
    register: "Kreye Kont",
    logout: "Dekonekte",
    email: "Imèl",
    password: "Modpas",
    confirmPassword: "Konfime Modpas",
    username: "Non itilizatè",
    displayName: "Non afiche",
    forgotPassword: "Bliye modpas?",
    noAccount: "Pa gen kont? Enskri",
    hasAccount: "Gentan gen kont? Konekte",
    loginSuccess: "Ou konekte!",
    registerSuccess: "Kont kreye!",
    
    // Profile
    profile: "Pwofil",
    editProfile: "Modifye Pwofil",
    bio: "Byografi",
    followers: "Abòne",
    following: "Swiv",
    posts: "Pòs",
    follow: "Swiv",
    unfollow: "Sispann Swiv",
    blocked: "Bloke",
    
    // Feed
    home: "Akèy",
    feed: "Fil Aktyalite",
    explore: "Eksplore",
    newPost: "Nouvo Pòs",
    whatsHappening: "Kisa k ap pase?",
    post: "Poste",
    like: "Renmen",
    comment: "Kòmantè",
    share: "Pataje",
    comments: "Kòmantè yo",
    noPostsYet: "Pa gen pòs ankò",
    startFollowing: "Kòmanse swiv moun pou wè pòs yo",
    
    // Chat
    chat: "Chat",
    chats: "Konvèsasyon",
    messages: "Mesaj",
    newMessage: "Nouvo Mesaj",
    typeMessage: "Tape yon mesaj...",
    send: "Voye",
    online: "Anliy",
    offline: "Pa anliy",
    sent: "Voye",
    delivered: "Livre",
    seen: "Li",
    newChat: "Nouvo Chat",
    groupChat: "Chat Gwoup",
    
    // Notifications
    notifications: "Notifikasyon",
    noNotifications: "Pa gen notifikasyon",
    markAllRead: "Make tout li",
    newFollower: "kòmanse swiv ou",
    likedPost: "renmen pòs ou a",
    commentedPost: "kòmante sou pòs ou a",
    sentMessage: "voye yon mesaj",
    
    // Search
    search: "Chèche",
    searchUsers: "Chèche itilizatè...",
    noResults: "Pa gen rezilta",
    
    // Settings
    settings: "Paramèt",
    language: "Lang",
    theme: "Tèm",
    darkMode: "Mòd Fènwa",
    lightMode: "Mòd Limyè",
    privacy: "Vi Prive",
    privateAccount: "Kont Prive",
    blockedUsers: "Itilizatè Bloke",
    deleteAccount: "Efase Kont",
    about: "Sou Nou",
    help: "Èd",
    termsOfUse: "Kondisyon Itilizasyon",
    privacyPolicy: "Politik Vi Prive",
    
    // Actions
    save: "Anrejistre",
    cancel: "Anile",
    delete: "Efase",
    report: "Rapòte",
    block: "Bloke",
    unblock: "Debloke",
    confirm: "Konfime",
    
    // Errors
    error: "Erè",
    errorOccurred: "Yon erè pase",
    tryAgain: "Eseye ankò",
    invalidCredentials: "Imèl oswa modpas pa bon",
    emailTaken: "Imèl sa a deja itilize",
    usernameTaken: "Non itilizatè sa a deja pran",
    
    // Success
    success: "Siksè",
    saved: "Anrejistre!",
    posted: "Poste!",
    deleted: "Efase!",
    
    // Time
    now: "kounye a",
    minutesAgo: "min pase",
    hoursAgo: "è pase",
    daysAgo: "jou pase",
    
    // Empty states
    noPosts: "Pa gen pòs ankò",
    noChats: "Pa gen konvèsasyon",
    noFollowers: "Pa gen abòne",
    noFollowing: "Pa swiv pèsòn",
    
    // Appointments
    appointments: "Randevou",
    manageAppointments: "Jere randevou ou yo",
    myServices: "Mwen Bay Sèvis",
    myAppointments: "Randevou Mwen",
    bookAppointment: "Pran Randevou",
    chooseDate: "Chwazi Dat",
    chooseTime: "Chwazi Lè",
    noSlotsAvailable: "Pa gen slot disponib pou jou sa a",
    fullName: "Non Konplè",
    emailAddress: "Adrès Email",
    phoneNumber: "Nimewo Telefòn",
    notesOptional: "Nòt (Opsyonèl)",
    messageToProvider: "Mesaj pou provider la...",
    continueBtn: "Kontinye",
    back: "Retounen",
    appointmentSummary: "Rezime Randevou",
    service: "Sèvis",
    date: "Dat",
    time: "Lè",
    duration: "Dire",
    minutes: "minit",
    price: "Pri",
    free: "Gratis",
    name: "Non",
    phone: "Telefòn",
    confirmBooking: "Konfime Randevou",
    appointmentCreated: "Randevou kreye! Provider la pral konfime.",
    fillAllFields: "Ranpli tout enfòmasyon yo",
    invalidEmail: "Mete yon adrès email valid",
    cannotCreateAppointment: "Pa ka kreye randevou",
    pending: "Ap Tann",
    confirmed: "Konfime",
    completed: "Fini",
    cancelled: "Anile",
    rejected: "Refize",
    all: "Tout",
    accept: "Aksepte",
    reject: "Refize",
    cancel: "Anile",
    markComplete: "Make Fini",
    noAppointments: "Pa gen randevou",
    whenClientsBook: "Lè kliyan pran randevou avèk ou, yo pral parèt isit",
    whenYouBook: "Lè ou pran randevou, yo pral parèt isit",
    appointmentConfirmed: "Randevou konfime!",
    appointmentRejected: "Randevou refize!",
    appointmentUpdated: "Randevou mete ajou!",
    appointmentCancelled: "Randevou anile!",
    confirmCancel: "Ou sèten ou vle anile randevou sa a?",
    
    // Payment
    payment: "Peman",
    payNow: "Peye Kounye a",
    payLater: "Peye Pita",
    payWithPayPal: "Peye ak PayPal",
    payWithCard: "Peye ak Kat",
    paymentRequired: "Peman obligatwa pou konfime randevou",
    paymentSuccess: "Peman reyisi!",
    paymentFailed: "Peman echwe",
    proceedToPayment: "Ale nan Peman",
    
    // Landing Page
    theFutureOfSocial: "Lavni Rezo Sosyal",
    whereCreators: "Kote Kreyatè yo",
    thriveAndEarn: "Grandi & Touche Lajan",
    landingSubheadline: "Yon platfòm sosyal modèn kote lide, foto, ak videyo viv ansanm — epi kreyatè yo fè kominote yo grandi ak revni yo ogmante.",
    startCreatingFree: "Kòmanse Kreye Gratis",
    exploreContent: "Eksplore Kontni",
    everythingYouNeed: "Tout Sa Ou Bezwen pou",
    succeed: "Reyisi",
    powerfulTools: "Zouti pwisan ki fèt pou kreyatè modèn yo",
    liveStreaming: "Live Streaming",
    liveStreamingDesc: "Fè live epi konekte ak odians ou an dirèk",
    aiCreatorStudio: "AI Creator Studio",
    aiCreatorStudioDesc: "Kreye videyo ak imaj estipefyan ak AI",
    creatorEconomy: "Ekonomi Kreyatè",
    creatorEconomyDesc: "Touche kòb, tip, ak abònman nan men fanatik ou yo",
    safeAndSecure: "Sekirize & Pwoteje",
    safeAndSecureDesc: "Vi prive ak sekirite ou se priyorite nou",
    lovedByCreators: "Kreyatè toupatou renmen li",
    joinTheRevolution: "Vin fè pati",
    revolution: "Revolisyon an",
    joinRevolutionDesc: "Dè milye kreyatè deja fè FityH lakay yo. Kòmanse vwayaj ou jodi a epi debloké tout potansyèl ou.",
    globalCommunity: "Kominote Mondyal",
    creatorRewards: "Rekonpans Kreyatè",
    supportiveCulture: "Kilti Sipòtif",
    createYourAccount: "Kreye Kont Ou",
    privacy: "Konfidansyalite",
    rules: "Règ yo",
    contactUs: "Kontakte Nou",
    allRightsReserved: "Tout dwa rezève.",
    
    // Marketplace
    marketplace: "Mache",
    searchProducts: "Chèche pwodwi...",
    noProducts: "Pa gen pwodwi",
    startSelling: "Kòmanse vann premye pwodwi ou!",
    listAProduct: "Mete yon pwodwi",
    sell: "Vann",
    all: "Tout"
  },

  fr: {
    // App
    appName: "FityH",
    tagline: "Connectez. Partagez. Vivez.",
    
    // Auth
    login: "Connexion",
    register: "S'inscrire",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    username: "Nom d'utilisateur",
    displayName: "Nom affiché",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas de compte ? Inscrivez-vous",
    hasAccount: "Déjà un compte ? Connectez-vous",
    loginSuccess: "Connecté !",
    registerSuccess: "Compte créé !",
    
    // Profile
    profile: "Profil",
    editProfile: "Modifier le profil",
    bio: "Bio",
    followers: "Abonnés",
    following: "Abonnements",
    posts: "Publications",
    follow: "Suivre",
    unfollow: "Ne plus suivre",
    blocked: "Bloqué",
    
    // Feed
    home: "Accueil",
    feed: "Fil d'actualité",
    explore: "Explorer",
    newPost: "Nouvelle publication",
    whatsHappening: "Quoi de neuf ?",
    post: "Publier",
    like: "J'aime",
    comment: "Commenter",
    share: "Partager",
    comments: "Commentaires",
    noPostsYet: "Pas encore de publications",
    startFollowing: "Commencez à suivre des personnes pour voir leurs publications",
    
    // Chat
    chat: "Discussion",
    chats: "Conversations",
    messages: "Messages",
    newMessage: "Nouveau message",
    typeMessage: "Tapez un message...",
    send: "Envoyer",
    online: "En ligne",
    offline: "Hors ligne",
    sent: "Envoyé",
    delivered: "Livré",
    seen: "Vu",
    newChat: "Nouvelle discussion",
    groupChat: "Discussion de groupe",
    
    // Notifications
    notifications: "Notifications",
    noNotifications: "Pas de notifications",
    markAllRead: "Tout marquer comme lu",
    newFollower: "a commencé à vous suivre",
    likedPost: "a aimé votre publication",
    commentedPost: "a commenté votre publication",
    sentMessage: "vous a envoyé un message",
    
    // Search
    search: "Rechercher",
    searchUsers: "Rechercher des utilisateurs...",
    noResults: "Aucun résultat",
    
    // Settings
    settings: "Paramètres",
    language: "Langue",
    theme: "Thème",
    darkMode: "Mode sombre",
    lightMode: "Mode clair",
    privacy: "Confidentialité",
    privateAccount: "Compte privé",
    blockedUsers: "Utilisateurs bloqués",
    deleteAccount: "Supprimer le compte",
    about: "À propos",
    help: "Aide",
    termsOfUse: "Conditions d'utilisation",
    privacyPolicy: "Politique de confidentialité",
    
    // Actions
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    report: "Signaler",
    block: "Bloquer",
    unblock: "Débloquer",
    confirm: "Confirmer",
    
    // Errors
    error: "Erreur",
    errorOccurred: "Une erreur s'est produite",
    tryAgain: "Réessayer",
    invalidCredentials: "Email ou mot de passe incorrect",
    emailTaken: "Email déjà utilisé",
    usernameTaken: "Nom d'utilisateur déjà pris",
    
    // Success
    success: "Succès",
    saved: "Enregistré !",
    posted: "Publié !",
    deleted: "Supprimé !",
    
    // Time
    now: "maintenant",
    minutesAgo: "min",
    hoursAgo: "heures",
    daysAgo: "jours",
    
    // Empty states
    noPosts: "Pas encore de publications",
    noChats: "Pas de conversations",
    noFollowers: "Pas d'abonnés",
    noFollowing: "Aucun abonnement",
    
    // Appointments
    appointments: "Rendez-vous",
    manageAppointments: "Gérer vos rendez-vous",
    myServices: "Je Fournis des Services",
    myAppointments: "Mes Rendez-vous",
    bookAppointment: "Prendre Rendez-vous",
    chooseDate: "Choisir la Date",
    chooseTime: "Choisir l'Heure",
    noSlotsAvailable: "Pas de créneaux disponibles pour ce jour",
    fullName: "Nom Complet",
    emailAddress: "Adresse Email",
    phoneNumber: "Numéro de Téléphone",
    notesOptional: "Notes (Optionnel)",
    messageToProvider: "Message pour le prestataire...",
    continueBtn: "Continuer",
    back: "Retour",
    appointmentSummary: "Résumé du Rendez-vous",
    service: "Service",
    date: "Date",
    time: "Heure",
    duration: "Durée",
    minutes: "minutes",
    price: "Prix",
    free: "Gratuit",
    name: "Nom",
    phone: "Téléphone",
    confirmBooking: "Confirmer le Rendez-vous",
    appointmentCreated: "Rendez-vous créé ! Le prestataire confirmera.",
    fillAllFields: "Remplissez tous les champs obligatoires",
    invalidEmail: "Entrez une adresse email valide",
    cannotCreateAppointment: "Impossible de créer le rendez-vous",
    pending: "En attente",
    confirmed: "Confirmé",
    completed: "Terminé",
    cancelled: "Annulé",
    rejected: "Refusé",
    all: "Tous",
    accept: "Accepter",
    reject: "Refuser",
    cancel: "Annuler",
    markComplete: "Marquer Terminé",
    noAppointments: "Pas de rendez-vous",
    whenClientsBook: "Quand des clients prennent rendez-vous, ils apparaîtront ici",
    whenYouBook: "Quand vous prenez rendez-vous, ils apparaîtront ici",
    appointmentConfirmed: "Rendez-vous confirmé !",
    appointmentRejected: "Rendez-vous refusé !",
    appointmentUpdated: "Rendez-vous mis à jour !",
    appointmentCancelled: "Rendez-vous annulé !",
    confirmCancel: "Êtes-vous sûr de vouloir annuler ce rendez-vous ?",
    
    // Payment
    payment: "Paiement",
    payNow: "Payer Maintenant",
    payLater: "Payer Plus Tard",
    payWithPayPal: "Payer avec PayPal",
    payWithCard: "Payer par Carte",
    paymentRequired: "Paiement requis pour confirmer la réservation",
    paymentSuccess: "Paiement réussi !",
    paymentFailed: "Échec du paiement",
    proceedToPayment: "Procéder au Paiement"
  },

  es: {
    // App
    appName: "FityH",
    tagline: "Conecta. Comparte. Vive.",
    
    // Auth
    login: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    username: "Nombre de usuario",
    displayName: "Nombre para mostrar",
    forgotPassword: "¿Olvidaste tu contraseña?",
    noAccount: "¿No tienes cuenta? Regístrate",
    hasAccount: "¿Ya tienes cuenta? Inicia sesión",
    loginSuccess: "¡Conectado!",
    registerSuccess: "¡Cuenta creada!",
    
    // Profile
    profile: "Perfil",
    editProfile: "Editar perfil",
    bio: "Biografía",
    followers: "Seguidores",
    following: "Siguiendo",
    posts: "Publicaciones",
    follow: "Seguir",
    unfollow: "Dejar de seguir",
    blocked: "Bloqueado",
    
    // Feed
    home: "Inicio",
    feed: "Noticias",
    explore: "Explorar",
    newPost: "Nueva publicación",
    whatsHappening: "¿Qué está pasando?",
    post: "Publicar",
    like: "Me gusta",
    comment: "Comentar",
    share: "Compartir",
    comments: "Comentarios",
    noPostsYet: "Aún no hay publicaciones",
    startFollowing: "Empieza a seguir personas para ver sus publicaciones",
    
    // Chat
    chat: "Chat",
    chats: "Conversaciones",
    messages: "Mensajes",
    newMessage: "Nuevo mensaje",
    typeMessage: "Escribe un mensaje...",
    send: "Enviar",
    online: "En línea",
    offline: "Desconectado",
    sent: "Enviado",
    delivered: "Entregado",
    seen: "Visto",
    newChat: "Nuevo chat",
    groupChat: "Chat de grupo",
    
    // Notifications
    notifications: "Notificaciones",
    noNotifications: "Sin notificaciones",
    markAllRead: "Marcar todo como leído",
    newFollower: "empezó a seguirte",
    likedPost: "le gustó tu publicación",
    commentedPost: "comentó tu publicación",
    sentMessage: "te envió un mensaje",
    
    // Search
    search: "Buscar",
    searchUsers: "Buscar usuarios...",
    noResults: "Sin resultados",
    
    // Settings
    settings: "Configuración",
    language: "Idioma",
    theme: "Tema",
    darkMode: "Modo oscuro",
    lightMode: "Modo claro",
    privacy: "Privacidad",
    privateAccount: "Cuenta privada",
    blockedUsers: "Usuarios bloqueados",
    deleteAccount: "Eliminar cuenta",
    about: "Acerca de",
    help: "Ayuda",
    termsOfUse: "Términos de uso",
    privacyPolicy: "Política de privacidad",
    
    // Actions
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    report: "Reportar",
    block: "Bloquear",
    unblock: "Desbloquear",
    confirm: "Confirmar",
    
    // Errors
    error: "Error",
    errorOccurred: "Ocurrió un error",
    tryAgain: "Intentar de nuevo",
    invalidCredentials: "Email o contraseña incorrectos",
    emailTaken: "Email ya registrado",
    usernameTaken: "Nombre de usuario ya tomado",
    
    // Success
    success: "Éxito",
    saved: "¡Guardado!",
    posted: "¡Publicado!",
    deleted: "¡Eliminado!",
    
    // Time
    now: "ahora",
    minutesAgo: "min",
    hoursAgo: "horas",
    daysAgo: "días",
    
    // Empty states
    noPosts: "Aún no hay publicaciones",
    noChats: "Sin conversaciones",
    noFollowers: "Sin seguidores",
    noFollowing: "No sigue a nadie",
    
    // Appointments
    appointments: "Citas",
    manageAppointments: "Gestionar tus citas",
    myServices: "Ofrezco Servicios",
    myAppointments: "Mis Citas",
    bookAppointment: "Reservar Cita",
    chooseDate: "Elegir Fecha",
    chooseTime: "Elegir Hora",
    noSlotsAvailable: "No hay horarios disponibles para este día",
    fullName: "Nombre Completo",
    emailAddress: "Correo Electrónico",
    phoneNumber: "Número de Teléfono",
    notesOptional: "Notas (Opcional)",
    messageToProvider: "Mensaje para el proveedor...",
    continueBtn: "Continuar",
    back: "Volver",
    appointmentSummary: "Resumen de la Cita",
    service: "Servicio",
    date: "Fecha",
    time: "Hora",
    duration: "Duración",
    minutes: "minutos",
    price: "Precio",
    free: "Gratis",
    name: "Nombre",
    phone: "Teléfono",
    confirmBooking: "Confirmar Cita",
    appointmentCreated: "¡Cita creada! El proveedor confirmará.",
    fillAllFields: "Complete todos los campos requeridos",
    invalidEmail: "Ingrese un email válido",
    cannotCreateAppointment: "No se puede crear la cita",
    pending: "Pendiente",
    confirmed: "Confirmada",
    completed: "Completada",
    cancelled: "Cancelada",
    rejected: "Rechazada",
    all: "Todas",
    accept: "Aceptar",
    reject: "Rechazar",
    cancel: "Cancelar",
    markComplete: "Marcar Completada",
    noAppointments: "Sin citas",
    whenClientsBook: "Cuando los clientes reserven citas contigo, aparecerán aquí",
    whenYouBook: "Cuando reserves citas, aparecerán aquí",
    appointmentConfirmed: "¡Cita confirmada!",
    appointmentRejected: "¡Cita rechazada!",
    appointmentUpdated: "¡Cita actualizada!",
    appointmentCancelled: "¡Cita cancelada!",
    confirmCancel: "¿Estás seguro de que quieres cancelar esta cita?",
    
    // Payment
    payment: "Pago",
    payNow: "Pagar Ahora",
    payLater: "Pagar Después",
    payWithPayPal: "Pagar con PayPal",
    payWithCard: "Pagar con Tarjeta",
    paymentRequired: "Pago requerido para confirmar la reserva",
    paymentSuccess: "¡Pago exitoso!",
    paymentFailed: "Pago fallido",
    proceedToPayment: "Proceder al Pago"
  }
};

// Language names for display
export const languageNames = {
  en: 'English',
  ht: 'Kreyòl Ayisyen',
  fr: 'Français',
  es: 'Español'
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};

// Returns a Proxy that works both as:
// - tr.key (object property access)  
// - tr('key') (function call)
export const t = (lang) => {
  const langObj = translations[lang] || translations.en;
  
  // Use Proxy to support both function call and property access
  return new Proxy(() => {}, {
    // Handle function calls: tr('key')
    apply: (target, thisArg, args) => {
      const key = args[0];
      return langObj[key] || translations.en[key] || key;
    },
    // Handle property access: tr.key
    get: (target, prop) => {
      if (prop === 'then') return undefined; // Prevent Promise confusion
      return langObj[prop] || translations.en[prop] || prop;
    }
  });
};

export default translations;
